import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=1fab02ce&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ploi/www.continental-holdings.com/web/app/themes/chc-wp-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fab02ce')) {
      api.createRecord('1fab02ce', component.options)
    } else {
      api.reload('1fab02ce', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=1fab02ce&", function () {
      api.rerender('1fab02ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vendor/vue-js-modal/components/Dialog.vue"
export default component.exports